import { PropsWithChildren, isValidElement } from 'react';

import { ListRow, Text } from '@betterment/samba-react';

import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

interface RootProps extends PropsWithChildren {
  css?: SystemStyleObject;
}

function Root({ children, css: cssProp, ...props }: RootProps) {
  return (
    <ListRow
      css={{
        paddingLeft: 'space.0',
        paddingRight: 'space.0',
        '& > * + *': { paddingLeft: 'space.300' },
        ...cssProp,
      }}
      {...props}
    >
      {children}
    </ListRow>
  );
}

function Label({ children, id, ...props }: PropsWithChildren & { id?: string }) {
  return (
    <ListRow.LeadingContent {...props}>
      <Text id={id}>{children}</Text>
    </ListRow.LeadingContent>
  );
}

function PrimaryText({ children }: PropsWithChildren) {
  return <Text>{children}</Text>;
}

function SecondaryText({ children }: PropsWithChildren) {
  return (
    <Text variant="text50" color="text.weak">
      {children}
    </Text>
  );
}

function Value({ children, ...props }: PropsWithChildren) {
  const hasNestedComponents =
    Array.isArray(children) ||
    (isValidElement(children) && (children.type === PrimaryText || children.type === SecondaryText));

  const content = hasNestedComponents ? children : <Text>{children}</Text>;

  return <ListRow.TrailingContent {...props}>{content}</ListRow.TrailingContent>;
}

export const SaleDetailsRow = Object.assign(Root, {
  Label,
  Value: Object.assign(Value, {
    Primary: PrimaryText,
    Secondary: SecondaryText,
  }),
});
